import React, { useState } from 'react';

import GoogleMapsSearch from '@common/fields/AddressField/GoogleMapsSearch';
import SelectField from '@common/fields/SelectField';
import { mapAddressDetailsToString } from '@common/utils/hooks/google/utils';
import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';

import { OTHER_ADDRESS_KEY, useAddress } from './AddressContext';

interface Props {
  meetingType: string;
  showMap?: boolean;
}

export default function AddressPicker({ meetingType, showMap }: Props) {
  const { t } = useScopedTranslation();
  const [formattedAddress, setFormattedAddress] = useState('');

  const {
    address,
    addressKey,
    addresses,
    onChangeAddress,
    onChangeAddressKey,
  } = useAddress();

  return (
    <>
      <SelectField
        name="address"
        nullable={false}
        onChange={onChangeAddressKey}
        placeholderRight={
          showMap
            ? undefined
            : t(`main_form.offices.other_address.${meetingType.toLowerCase()}`)
        }
        value={addressKey}
      >
        {Object.keys(addresses).map((addressKey) => (
          <option key={addressKey} value={addressKey}>
            {addresses[addressKey].label}
          </option>
        ))}
        <option value="other">
          {t(`main_form.offices.other_address.${meetingType.toLowerCase()}`)}
        </option>
      </SelectField>
      <GoogleMapsSearch
        disabled={addressKey !== OTHER_ADDRESS_KEY}
        location={address?.location}
        name="Address"
        onChangeAddress={onChangeAddress}
        onChangeSearchString={setFormattedAddress}
        searchString={
          addressKey === OTHER_ADDRESS_KEY
            ? formattedAddress
            : mapAddressDetailsToString(address ?? {}, ', ')
        }
        showMap={showMap}
      />
    </>
  );
}
